<template>
  <b-form-group
    :label="$t('fields.description')"
    label-for="description"
  >
    <b-form-textarea
      id="description"
      v-model="dataItem.description"
      :placeholder="$t('guides.form.descriptionPlaceholder')"
      rows="4"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormTextarea } from 'bootstrap-vue'

export default {
  name: 'GuidesDescriptionCard',
  components: { BFormGroup, BFormTextarea },
  computed: {
    dataItem() {
      return this.$store.getters['guides/dataItem']
    },
  },
}
</script>
